import React, { Component } from 'react';

export default class EDSFooter extends Component {
    render() {
        const year = new Date().getFullYear();
        return (
            <footer className="footer"> 
                <p>{'Copyrights EGURROLA DANCE STUDIO ' + year + ' ©    |    Baked by adcookie' }</p>
            </footer>
        );
    }
}
